/* ============================================================
   RF2T Pac-Man Easter Egg
   ------------------------------------------------------------
   When a shopper searches for "pacman" (any spacing/spelling),
   a coin-op style button slides up. Clicking it opens a modal
   with a self-contained Pac-Man clone rendered on <canvas>:
   maze, dots, power pellets, four ghosts with the classic
   scatter/chase/frightened AI, lives, levels, WebAudio SFX and
   keyboard + touch controls.

   Loaded once globally from theme.liquid; a single delegated
   listener watches every search box (header, predictive, drawer,
   search page) and survives spa-nav content swaps.
   ============================================================ */
(function () {
  'use strict';

  if (window.__rf2tPacBound) return;
  window.__rf2tPacBound = true;

  /* ─────────────────────────────────────────────────────────
     Maze (verified fully-connected, zero dead-ends: 199 dots + 4 power)
       #  wall          .  dot           o  power pellet
       -  ghost door    G  ghost house   P  pac-man start
     A full outer ring plus five vertical corridors give plenty of
     loops to flow around ghosts. Row 10 wraps left<->right (tunnel).
     ───────────────────────────────────────────────────────── */
  var RAW_MAZE = [
    '###################',
    '#.................#',
    '#o###.###.###.###o#',
    '#.................#',
    '#.###.###.###.###.#',
    '#.................#',
    '#.###.###.###.###.#',
    '#.................#',
    '#.###.###-###.###.#',
    '#.###.##GGG##.###.#',
    ' .###.##GGG##.###. ',
    '#.###.#######.###.#',
    '#.................#',
    '#.###.###.###.###.#',
    '#.................#',
    '#.###.###.###.###.#',
    '#........P........#',
    '#.###.###.###.###.#',
    '#.................#',
    '#o###.###.###.###o#',
    '#.................#',
    '###################'
  ];

  var COLS = 19;
  var ROWS = 22;
  var TILE = 22;
  var HUD_TOP = 42;     // px above the maze for score row
  var HUD_BOTTOM = 40;  // px below the maze for lives / level
  var VW = COLS * TILE;                       // 418
  var VH = HUD_TOP + ROWS * TILE + HUD_BOTTOM;// 562

  var HOME = { x: 9, y: 9 };  // ghost-house centre (revive target)
  var EXIT = { x: 9, y: 7 };  // tile just above the door (house exit)
  var START = { x: 9, y: 16 };

  var DIRS = {
    up: { x: 0, y: -1 }, down: { x: 0, y: 1 },
    left: { x: -1, y: 0 }, right: { x: 1, y: 0 },
    none: { x: 0, y: 0 }
  };
  var OPP = { up: 'down', down: 'up', left: 'right', right: 'left', none: 'none' };

  var HIGH_KEY = 'rf2t_pacman_high';

  /* ─────────────────────────────────────────────────────────
     Trigger detection
     ───────────────────────────────────────────────────────── */
  function normalize(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function isPacman(s) {
    var n = normalize(s);
    if (!n) return false;
    return n.indexOf('pacman') !== -1 || n.indexOf('packman') !== -1 || n.indexOf('pakman') !== -1;
  }

  var trigger = null;
  var game = null;

  function ensureTrigger() {
    if (trigger) return trigger;
    trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'rf2t-pac-trigger';
    trigger.setAttribute('aria-label', 'Secret found — play Pac-Man');
    trigger.innerHTML =
      '<span class="rf2t-pac-trigger__icon" aria-hidden="true">' +
        '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">' +
          '<circle cx="16" cy="16" r="14" fill="#ffd24a"/>' +
          '<circle cx="14" cy="9" r="1.6" fill="#0b1030"/>' +
          '<path class="rf2t-pac-trigger__mouth" d="M16 16 L33 7 L33 25 Z" fill="#0b1030"/>' +
        '</svg>' +
      '</span>' +
      '<span class="rf2t-pac-trigger__label">Play Pac-Man' +
        '<span class="rf2t-pac-trigger__hint">A wild secret appeared!</span>' +
      '</span>';
    trigger.addEventListener('click', function () {
      hideTrigger();
      openGame();
    });
    document.body.appendChild(trigger);
    return trigger;
  }

  function showTrigger() {
    if (game) return; // already playing
    ensureTrigger().classList.add('is-visible');
  }
  function hideTrigger() {
    if (trigger) trigger.classList.remove('is-visible');
  }

  // Live typing in any search box.
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (!t || (t.name !== 'q' && t.getAttribute && t.getAttribute('name') !== 'q')) return;
    if (isPacman(t.value)) showTrigger(); else hideTrigger();
  });

  // Direct loads / spa-nav onto a results page (?q=pacman) or pre-filled inputs.
  function scanExisting() {
    try {
      var q = new URLSearchParams(window.location.search).get('q');
      if (isPacman(q)) { showTrigger(); return; }
    } catch (_) { /* ignore */ }
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) {
      if (isPacman(inputs[i].value)) { showTrigger(); return; }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanExisting);
  } else {
    scanExisting();
  }
  window.addEventListener('popstate', function () { setTimeout(scanExisting, 60); });

  /* ─────────────────────────────────────────────────────────
     Tiny DOM helpers
     ───────────────────────────────────────────────────────── */
  function el(tag, cls) { var n = document.createElement(tag); if (cls) n.className = cls; return n; }
  function toolBtn(label, aria) {
    var b = el('button', 'rf2t-pac-btn');
    b.type = 'button';
    b.innerHTML = label;
    b.setAttribute('aria-label', aria);
    return b;
  }

  /* ─────────────────────────────────────────────────────────
     Game
     ───────────────────────────────────────────────────────── */
  function openGame() {
    if (game) return;
    game = new PacGame();
    game.mount();
  }

  function PacGame() {
    this.raf = 0;
    this.last = 0;
    this.running = false;
    this.paused = false;
    this.muted = false;
  }

  PacGame.prototype.mount = function () {
    var self = this;

    // ---- DOM ----
    var overlay = el('div', 'rf2t-pac-overlay');
    var modal = el('div', 'rf2t-pac-modal');

    var bar = el('div', 'rf2t-pac-bar');
    var title = el('h2', 'rf2t-pac-title');
    title.innerHTML = 'PAC&#8209;<span>FIX</span>';
    var tools = el('div', 'rf2t-pac-tools');
    var muteBtn = toolBtn('&#128266;', 'Toggle sound');
    var pauseBtn = toolBtn('&#10073;&#10073;', 'Pause');
    var closeBtn = toolBtn('&#10005;', 'Close game');
    tools.appendChild(muteBtn); tools.appendChild(pauseBtn); tools.appendChild(closeBtn);
    bar.appendChild(title); bar.appendChild(tools);

    var canvas = el('canvas', 'rf2t-pac-canvas');
    canvas.tabIndex = 0;

    var footer = el('div', 'rf2t-pac-footer');
    var help = el('p', 'rf2t-pac-help');
    help.textContent = 'Arrow keys / WASD to move  ·  P pause  ·  Esc close';
    var dpad = el('div', 'rf2t-pac-dpad');
    ['up', 'left', 'right', 'down'].forEach(function (dir) {
      var b = el('button', 'rf2t-pac-dpad__btn');
      b.type = 'button';
      b.setAttribute('data-dir', dir);
      b.setAttribute('aria-label', 'Move ' + dir);
      b.innerHTML = { up: '&#9650;', down: '&#9660;', left: '&#9664;', right: '&#9654;' }[dir];
      dpad.appendChild(b);
    });
    footer.appendChild(help); footer.appendChild(dpad);

    modal.appendChild(bar); modal.appendChild(canvas); modal.appendChild(footer);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    document.documentElement.classList.add('rf2t-pac-noscroll');

    this.overlay = overlay;
    this.canvas = canvas;
    this.muteBtn = muteBtn;
    this.pauseBtn = pauseBtn;

    // ---- Canvas buffer (hi-dpi crisp) ----
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = VW * dpr;
    canvas.height = VH * dpr;
    var ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    this.ctx = ctx;
    this.fit();

    // ---- Audio ----
    this.initAudio();

    // ---- State ----
    this.highScore = parseInt(localStorage.getItem(HIGH_KEY), 10) || 0;
    this.newGame();

    // ---- Listeners ----
    this.onKey = function (e) { self.handleKey(e); };
    document.addEventListener('keydown', this.onKey, true);

    this.onResize = function () { self.fit(); };
    window.addEventListener('resize', this.onResize);

    this.onVis = function () { if (document.hidden) self.setPaused(true); };
    document.addEventListener('visibilitychange', this.onVis);

    overlay.addEventListener('mousedown', function (e) { if (e.target === overlay) self.close(); });

    closeBtn.addEventListener('click', function () { self.close(); });
    pauseBtn.addEventListener('click', function () { self.setPaused(!self.paused); canvas.focus(); });
    muteBtn.addEventListener('click', function () { self.toggleMute(); canvas.focus(); });

    // d-pad
    dpad.addEventListener('pointerdown', function (e) {
      var b = e.target.closest('.rf2t-pac-dpad__btn');
      if (!b) return;
      e.preventDefault();
      self.queueDir(b.getAttribute('data-dir'));
    });

    // swipe + tap-to-restart on the canvas
    var sx = 0, sy = 0, swiping = false;
    canvas.addEventListener('pointerdown', function (e) {
      if (self.state === 'gameover') { self.newGame(); return; }
      sx = e.clientX; sy = e.clientY; swiping = true;
    });
    canvas.addEventListener('pointermove', function (e) {
      if (!swiping) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) < 24 && Math.abs(dy) < 24) return;
      swiping = false;
      if (Math.abs(dx) > Math.abs(dy)) self.queueDir(dx > 0 ? 'right' : 'left');
      else self.queueDir(dy > 0 ? 'down' : 'up');
    });
    canvas.addEventListener('pointerup', function () { swiping = false; });

    // requestAnimationFrame loop
    this.running = true;
    this.loop = function (ts) {
      if (!self.running) return;
      var dt = self.last ? (ts - self.last) / 1000 : 0;
      self.last = ts;
      if (dt > 0.05) dt = 0.05;
      self.step(dt, ts);
      self.raf = requestAnimationFrame(self.loop);
    };
    this.raf = requestAnimationFrame(this.loop);

    requestAnimationFrame(function () {
      overlay.classList.add('is-open');
      canvas.focus();
    });
  };

  PacGame.prototype.fit = function () {
    var availW = Math.min(window.innerWidth - 24, 560);
    var availH = window.innerHeight - 150;
    var scale = Math.min(availW / VW, availH / VH, 1.45);
    if (!(scale > 0)) scale = 1;
    this.canvas.style.width = Math.round(VW * scale) + 'px';
    this.canvas.style.height = Math.round(VH * scale) + 'px';
  };

  /* ---- Lifecycle ---- */
  PacGame.prototype.newGame = function () {
    this.score = 0;
    this.lives = 3;
    this.level = 1;
    this.recalc();
    this.loadLevel();
    this.intro = true;
    this.setReady(2.2);
    this.playReady();
  };

  PacGame.prototype.recalc = function () {
    var L = Math.min(this.level, 6);
    this.pacSpeed = 6.6 + (L - 1) * 0.28;
    this.ghostSpeed = 5.9 + (L - 1) * 0.32;
    this.frightSpeed = 3.4 + (L - 1) * 0.10;
    this.eatenSpeed = 13;
    this.frightDuration = Math.max(2, 7 - (L - 1) * 0.9);
  };

  PacGame.prototype.loadLevel = function () {
    // pellet grid from the maze
    this.pellets = [];
    this.dotsLeft = 0;
    for (var r = 0; r < ROWS; r++) {
      this.pellets[r] = [];
      for (var c = 0; c < COLS; c++) {
        var ch = RAW_MAZE[r][c];
        if (ch === '.') { this.pellets[r][c] = 1; this.dotsLeft++; }
        else if (ch === 'o') { this.pellets[r][c] = 2; this.dotsLeft++; }
        else this.pellets[r][c] = 0;
      }
    }
    this.resetActors();
  };

  PacGame.prototype.resetActors = function () {
    this.pac = { x: START.x, y: START.y, dir: 'none', want: 'none', facing: 'left' };

    this.globalMode = 'scatter';
    this.modeTimer = 7;
    this.frightActive = false;
    this.frightTimer = 0;
    this.ghostChain = 0;

    var mk = function (type, color, x, y, scatter, release) {
      return {
        type: type, color: color, x: x, y: y,
        dir: 'left', state: 'house', forceReverse: false,
        scatter: scatter, release: release, bob: Math.random() * Math.PI * 2
      };
    };
    this.ghosts = [
      mk('blinky', '#ff2d2d', EXIT.x, EXIT.y, { x: COLS - 2, y: 1 }, 0),
      mk('pinky', '#ffb3de', 9, 9, { x: 1, y: 1 }, 1.4),
      mk('inky', '#5ee0ff', 8, 10, { x: COLS - 2, y: ROWS - 2 }, 4.5),
      mk('clyde', '#ffb852', 10, 10, { x: 1, y: ROWS - 2 }, 8.5)
    ];
    // Blinky starts on the board, already hunting.
    this.ghosts[0].state = 'normal';
    this.ghosts[0].dir = 'left';
    this.levelTime = 0;
  };

  PacGame.prototype.setReady = function (t) { this.state = 'ready'; this.readyTimer = t; };

  PacGame.prototype.nextLevel = function () {
    this.level++;
    this.recalc();
    this.loadLevel();
    this.setReady(1.6);
    this.playReady();
  };

  PacGame.prototype.afterDeath = function () {
    this.lives--;
    if (this.lives <= 0) {
      this.state = 'gameover';
      if (this.score > this.highScore) {
        this.highScore = this.score;
        try { localStorage.setItem(HIGH_KEY, String(this.highScore)); } catch (_) {}
      }
      return;
    }
    this.resetActors();
    this.setReady(1.6);
  };

  /* ---- Main step ---- */
  PacGame.prototype.step = function (dt, now) {
    if (this.state === 'play' && !this.paused) {
      this.updatePlay(dt);
    } else if (this.state === 'ready') {
      this.readyTimer -= dt;
      if (this.readyTimer <= 0) { this.state = 'play'; this.intro = false; }
    } else if (this.state === 'dying') {
      this.dieTimer -= dt;
      if (this.dieTimer <= 0) this.afterDeath();
    } else if (this.state === 'levelclear') {
      this.clearTimer -= dt;
      if (this.clearTimer <= 0) this.nextLevel();
    }
    this.render(now);
  };

  PacGame.prototype.updatePlay = function (dt) {
    this.levelTime += dt;

    // scatter/chase schedule pauses while ghosts are frightened
    if (this.frightActive) {
      this.frightTimer -= dt;
      if (this.frightTimer <= 0) this.endFright();
    } else {
      this.modeTimer -= dt;
      if (this.modeTimer <= 0) this.swapMode();
    }

    // release ghosts from the house
    for (var i = 0; i < this.ghosts.length; i++) {
      var g = this.ghosts[i];
      if (g.state === 'house' && this.levelTime >= g.release) {
        g.state = 'leaving';
        g.dir = 'up';
        g.forceReverse = true;
      }
    }

    // move pac
    this.movePac(this.pacSpeed * dt);

    // move ghosts
    for (i = 0; i < this.ghosts.length; i++) {
      g = this.ghosts[i];
      if (g.state === 'house') continue;
      var spd = this.ghostSpeed;
      if (g.state === 'frightened') spd = this.frightSpeed;
      else if (g.state === 'eaten') spd = this.eatenSpeed;
      if (Math.round(g.y) === 10 && (Math.round(g.x) <= 4 || Math.round(g.x) >= 14)) spd *= 0.55;
      this.advance(g, spd * dt, this.ghostCenter, this);
    }

    this.collisions();
    if (this.dotsLeft <= 0) {
      this.state = 'levelclear';
      this.clearTimer = 1.8;
    }
  };

  /* ---- Movement: continuous, decisions taken exactly at tile centres ---- */
  PacGame.prototype.advance = function (e, budget, atCenter, self) {
    var guard = 0;
    while (budget > 1e-9 && guard++ < 40) {
      var onCenter = Math.abs(e.x - Math.round(e.x)) < 1e-6 && Math.abs(e.y - Math.round(e.y)) < 1e-6;
      if (onCenter) {
        e.x = Math.round(e.x);
        e.y = Math.round(e.y);
        atCenter.call(self, e);
      }
      var d = DIRS[e.dir];
      if (d.x === 0 && d.y === 0) break;

      var dist;
      if (d.x > 0) dist = (Math.floor(e.x) + 1) - e.x;
      else if (d.x < 0) dist = e.x - (Math.ceil(e.x) - 1);
      else if (d.y > 0) dist = (Math.floor(e.y) + 1) - e.y;
      else dist = e.y - (Math.ceil(e.y) - 1);
      if (dist < 1e-9) dist = 1;

      var travel = Math.min(budget, dist);
      e.x += d.x * travel;
      e.y += d.y * travel;
      budget -= travel;

      if (e.x < 0) e.x += COLS;
      else if (e.x >= COLS) e.x -= COLS;
    }
  };

  function tileChar(c, r) {
    if (r < 0 || r >= ROWS) return '#';
    c = ((c % COLS) + COLS) % COLS;
    return RAW_MAZE[r][c];
  }
  function pacBlocked(c, r) {
    var ch = tileChar(c, r);
    return ch === '#' || ch === '-' || ch === 'G';
  }
  function ghostBlocked(g, c, r) {
    var ch = tileChar(c, r);
    if (ch === '#') return true;
    if (ch === '-' || ch === 'G') return !(g.state === 'leaving' || g.state === 'eaten');
    return false;
  }

  // Pac movement with "cornering": a buffered perpendicular turn is taken as
  // soon as Pac is within TURN_TOL of an intersection (not only dead-centre),
  // so the controls feel immediate. Reverses apply instantly.
  PacGame.prototype.movePac = function (budget) {
    var p = this.pac;
    var TURN_TOL = 0.5;
    var guard = 0;
    while (budget > 1e-9 && guard++ < 40) {
      var c = Math.round(p.x), r = Math.round(p.y);

      // Apply the buffered direction early when possible.
      if (p.want !== 'none' && p.want !== p.dir) {
        if (p.dir !== 'none' && p.want === OPP[p.dir]) {
          p.dir = p.want; p.facing = p.dir;          // instant reverse
        } else {
          var wd = DIRS[p.want];
          if (!pacBlocked(c + wd.x, r + wd.y)) {
            if (wd.x !== 0 && Math.abs(p.y - r) <= TURN_TOL) {
              p.y = r; p.dir = p.want; p.facing = p.dir;
            } else if (wd.y !== 0 && Math.abs(p.x - c) <= TURN_TOL) {
              p.x = c; p.dir = p.want; p.facing = p.dir;
            }
          }
        }
      }

      // Exactly on a tile centre: eat, and stop if the way ahead is a wall.
      if (Math.abs(p.x - c) < 1e-6 && Math.abs(p.y - r) < 1e-6) {
        p.x = c; p.y = r;
        this.eatAt(c, r);
        var cd = DIRS[p.dir];
        if (!(cd.x === 0 && cd.y === 0)) {
          if (pacBlocked(c + cd.x, r + cd.y)) p.dir = 'none';
          else p.facing = p.dir;
        }
      }

      var d = DIRS[p.dir];
      if (d.x === 0 && d.y === 0) break;

      var dist;
      if (d.x > 0) dist = (Math.floor(p.x) + 1) - p.x;
      else if (d.x < 0) dist = p.x - (Math.ceil(p.x) - 1);
      else if (d.y > 0) dist = (Math.floor(p.y) + 1) - p.y;
      else dist = p.y - (Math.ceil(p.y) - 1);
      if (dist < 1e-9) dist = 1;

      var travel = Math.min(budget, dist);
      p.x += d.x * travel; p.y += d.y * travel;
      budget -= travel;

      if (p.x < 0) p.x += COLS;
      else if (p.x >= COLS) p.x -= COLS;
    }
  };

  PacGame.prototype.ghostCenter = function (g) {
    var c = Math.round(g.x), r = Math.round(g.y);

    if (g.state === 'eaten' && c === HOME.x && r === HOME.y) {
      g.state = 'leaving'; g.dir = 'up'; g.forceReverse = true;
    }
    if (g.state === 'leaving' && c === EXIT.x && r === EXIT.y) {
      g.state = this.frightActive ? 'frightened' : 'normal';
      g.dir = 'left'; g.forceReverse = true;
    }

    var target = this.ghostTarget(g, c, r);
    var options = [];
    var order = ['up', 'left', 'down', 'right'];
    for (var i = 0; i < order.length; i++) {
      var dir = order[i];
      if (dir === OPP[g.dir] && !g.forceReverse) continue;
      var d = DIRS[dir];
      if (!ghostBlocked(g, c + d.x, r + d.y)) options.push(dir);
    }
    g.forceReverse = false;

    var chosen;
    if (options.length === 0) {
      chosen = OPP[g.dir];
    } else if (g.state === 'frightened') {
      chosen = options[Math.floor(Math.random() * options.length)];
    } else {
      var best = Infinity;
      for (i = 0; i < options.length; i++) {
        var od = DIRS[options[i]];
        var nx = c + od.x, ny = r + od.y;
        var dd = (nx - target.x) * (nx - target.x) + (ny - target.y) * (ny - target.y);
        if (dd < best - 1e-9) { best = dd; chosen = options[i]; }
      }
    }
    g.dir = chosen;
  };

  PacGame.prototype.ghostTarget = function (g, c, r) {
    if (g.state === 'eaten') return HOME;
    if (g.state === 'leaving') return EXIT;
    if (this.globalMode === 'scatter') return g.scatter;

    var p = this.pac;
    var pc = { x: Math.round(p.x), y: Math.round(p.y) };
    var pd = DIRS[p.facing];
    switch (g.type) {
      case 'blinky':
        return pc;
      case 'pinky':
        return { x: pc.x + pd.x * 4, y: pc.y + pd.y * 4 };
      case 'inky': {
        var a = { x: pc.x + pd.x * 2, y: pc.y + pd.y * 2 };
        var b = this.ghosts[0];
        return { x: 2 * a.x - Math.round(b.x), y: 2 * a.y - Math.round(b.y) };
      }
      case 'clyde': {
        var dx = pc.x - c, dy = pc.y - r;
        return (dx * dx + dy * dy > 64) ? pc : g.scatter;
      }
    }
    return pc;
  };

  PacGame.prototype.swapMode = function () {
    this.globalMode = this.globalMode === 'scatter' ? 'chase' : 'scatter';
    this.modeTimer = this.globalMode === 'scatter' ? 6 : 20;
    for (var i = 0; i < this.ghosts.length; i++) {
      if (this.ghosts[i].state === 'normal') this.ghosts[i].forceReverse = true;
    }
  };

  PacGame.prototype.startFright = function () {
    this.ghostChain = 0;
    this.frightActive = true;
    this.frightTimer = this.frightDuration;
    for (var i = 0; i < this.ghosts.length; i++) {
      var g = this.ghosts[i];
      if (g.state === 'normal') { g.state = 'frightened'; g.forceReverse = true; }
    }
    this.sirenOn();
  };

  PacGame.prototype.endFright = function () {
    this.frightActive = false;
    for (var i = 0; i < this.ghosts.length; i++) {
      if (this.ghosts[i].state === 'frightened') this.ghosts[i].state = 'normal';
    }
  };

  PacGame.prototype.eatAt = function (c, r) {
    var v = this.pellets[r] && this.pellets[r][c];
    if (!v) return;
    this.pellets[r][c] = 0;
    this.dotsLeft--;
    if (v === 2) { this.score += 50; this.startFright(); this.bigEat(); }
    else { this.score += 10; this.waka(); }
    if (this.score > this.highScore) this.highScore = this.score;
  };

  PacGame.prototype.collisions = function () {
    var p = this.pac;
    for (var i = 0; i < this.ghosts.length; i++) {
      var g = this.ghosts[i];
      if (g.state === 'house' || g.state === 'leaving' || g.state === 'eaten') continue;
      var dx = g.x - p.x, dy = g.y - p.y;
      if (dx * dx + dy * dy < 0.42 * 0.42) {
        if (g.state === 'frightened') {
          g.state = 'eaten';
          var pts = 200 * Math.pow(2, this.ghostChain);
          this.ghostChain = Math.min(this.ghostChain + 1, 3);
          this.score += pts;
          if (this.score > this.highScore) this.highScore = this.score;
          this.eatGhostSound();
        } else {
          this.pac.dir = 'none';
          this.state = 'dying';
          this.dieTimer = 1.7;
          this.death();
        }
      }
    }
  };

  /* ---- Input ---- */
  PacGame.prototype.queueDir = function (dir) {
    var p = this.pac;
    p.want = dir;
    if (p.dir !== 'none' && dir === OPP[p.dir]) { p.dir = dir; p.facing = dir; return; }
    if (p.dir === 'none') {
      var c = Math.round(p.x), r = Math.round(p.y), d = DIRS[dir];
      if (!pacBlocked(c + d.x, r + d.y)) { p.dir = dir; p.facing = dir; }
    }
  };

  PacGame.prototype.handleKey = function (e) {
    var k = e.key;
    var dir = null;
    if (k === 'ArrowUp' || k === 'w' || k === 'W') dir = 'up';
    else if (k === 'ArrowDown' || k === 's' || k === 'S') dir = 'down';
    else if (k === 'ArrowLeft' || k === 'a' || k === 'A') dir = 'left';
    else if (k === 'ArrowRight' || k === 'd' || k === 'D') dir = 'right';

    if (dir) { e.preventDefault(); this.queueDir(dir); this.resumeAudio(); return; }

    if (k === 'Escape') { e.preventDefault(); this.close(); }
    else if (k === 'p' || k === 'P') { e.preventDefault(); this.setPaused(!this.paused); }
    else if (k === 'm' || k === 'M') { e.preventDefault(); this.toggleMute(); }
    else if ((k === 'r' || k === 'R') && this.state === 'gameover') { e.preventDefault(); this.newGame(); }
    else if (k === ' ' || k === 'Spacebar') { e.preventDefault(); if (this.state === 'gameover') this.newGame(); }
  };

  PacGame.prototype.setPaused = function (v) {
    this.paused = v;
    if (this.pauseBtn) this.pauseBtn.setAttribute('aria-pressed', v ? 'true' : 'false');
  };

  PacGame.prototype.close = function () {
    this.running = false;
    if (this.raf) cancelAnimationFrame(this.raf);
    document.removeEventListener('keydown', this.onKey, true);
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('visibilitychange', this.onVis);
    document.documentElement.classList.remove('rf2t-pac-noscroll');
    if (this.audio) { try { this.audio.close(); } catch (_) {} }
    var ov = this.overlay;
    ov.classList.remove('is-open');
    setTimeout(function () { if (ov && ov.parentNode) ov.parentNode.removeChild(ov); }, 260);
    game = null;
  };

  /* ─────────────────────────────────────────────────────────
     Rendering
     ───────────────────────────────────────────────────────── */
  function px(c) { return c * TILE + TILE / 2; }
  function py(r) { return HUD_TOP + r * TILE + TILE / 2; }

  PacGame.prototype.render = function (now) {
    var ctx = this.ctx;
    ctx.clearRect(0, 0, VW, VH);
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, VW, VH);

    this.drawMaze(now);
    this.drawPellets(now);
    if (this.state !== 'dying') this.drawGhosts(now);
    this.drawPac(now);
    this.drawHUD();
    this.drawMessages(now);
  };

  function rrect(ctx, x, y, w, h, r) {
    if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); return; }
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  PacGame.prototype.drawMaze = function (now) {
    var ctx = this.ctx;
    var flash = this.state === 'levelclear' && (Math.floor(now / 200) % 2 === 0);
    var fill = flash ? '#eef3ff' : '#1f3ac4';
    var stroke = flash ? '#ffffff' : '#5e7bff';
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        var ch = RAW_MAZE[r][c];
        if (ch === '#') {
          var x = c * TILE, y = HUD_TOP + r * TILE;
          rrect(ctx, x + 2, y + 2, TILE - 4, TILE - 4, 6);
          ctx.fillStyle = fill; ctx.fill();
          ctx.lineWidth = 1.5; ctx.strokeStyle = stroke; ctx.stroke();
        } else if (ch === '-') {
          ctx.fillStyle = '#ff9dc4';
          ctx.fillRect(c * TILE + 2, HUD_TOP + r * TILE + TILE / 2 - 2, TILE - 4, 4);
        }
      }
    }
  };

  PacGame.prototype.drawPellets = function (now) {
    var ctx = this.ctx;
    var blink = Math.floor(now / 250) % 2 === 0;
    ctx.fillStyle = '#ffd9a8';
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        var v = this.pellets[r][c];
        if (v === 1) {
          ctx.beginPath();
          ctx.arc(px(c), py(r), 2.2, 0, Math.PI * 2);
          ctx.fill();
        } else if (v === 2 && blink) {
          ctx.beginPath();
          ctx.arc(px(c), py(r), 5.5, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }
  };

  PacGame.prototype.drawPac = function (now) {
    var ctx = this.ctx;
    var p = this.pac;
    var x = px(p.x), y = py(p.y);
    var rad = TILE * 0.46;

    if (this.state === 'dying') {
      // mouth opens wide, then Pac vanishes
      var prog = 1 - this.dieTimer / 1.7;            // 0 -> 1
      var open = Math.min(prog * 1.05, 1) * Math.PI; // up to a full circle
      var rr = rad * Math.max(0, 1 - Math.max(0, prog - 0.85) / 0.15);
      if (rr <= 0.5) return;
      ctx.fillStyle = '#ffd24a';
      ctx.beginPath();
      ctx.moveTo(x, y);
      ctx.arc(x, y, rr, -Math.PI / 2 + open, -Math.PI / 2 + Math.PI * 2 - open);
      ctx.closePath();
      ctx.fill();
      return;
    }

    var open;
    if (p.dir === 'none') open = 0.12 * Math.PI;
    else open = (0.5 - 0.5 * Math.cos(now / 1000 * 18)) * 0.30 * Math.PI;
    var base = { right: 0, down: Math.PI / 2, left: Math.PI, up: -Math.PI / 2 }[p.facing || 'left'];

    ctx.fillStyle = '#ffd24a';
    ctx.beginPath();
    ctx.moveTo(x, y);
    ctx.arc(x, y, rad, base + open, base + Math.PI * 2 - open);
    ctx.closePath();
    ctx.fill();
  };

  PacGame.prototype.drawGhosts = function (now) {
    for (var i = 0; i < this.ghosts.length; i++) this.drawGhost(this.ghosts[i], now);
  };

  PacGame.prototype.drawGhost = function (g, now) {
    var ctx = this.ctx;
    var bob = (g.state === 'house') ? Math.sin(now / 220 + g.bob) * 3 : 0;
    var x = px(g.x), y = py(g.y) + bob;
    var r = TILE * 0.46;

    var body = true, scared = false, color = g.color;
    if (g.state === 'frightened') {
      scared = true;
      var endFlash = this.frightTimer < 2 && (Math.floor(now / 220) % 2 === 0);
      color = endFlash ? '#ffffff' : '#2828ff';
    } else if (g.state === 'eaten') {
      body = false;
    }

    if (body) {
      ctx.fillStyle = color;
      ctx.beginPath();
      ctx.arc(x, y, r, Math.PI, Math.PI * 2);   // top dome
      ctx.lineTo(x + r, y + r * 0.75);
      var feet = 4, w = (2 * r) / feet;
      for (var f = 0; f < feet; f++) {
        var xR = x + r - f * w;
        ctx.lineTo(xR - w / 2, y + r * 0.42);
        ctx.lineTo(xR - w, y + r * 0.75);
      }
      ctx.closePath();
      ctx.fill();
    }

    if (scared) {
      ctx.fillStyle = color === '#ffffff' ? '#ff5a5a' : '#ffd1dc';
      ctx.fillRect(x - r * 0.42, y - r * 0.18, r * 0.2, r * 0.2);
      ctx.fillRect(x + r * 0.22, y - r * 0.18, r * 0.2, r * 0.2);
      ctx.strokeStyle = color === '#ffffff' ? '#ff5a5a' : '#ffd1dc';
      ctx.lineWidth = 2;
      ctx.beginPath();
      var my = y + r * 0.35, mw = r * 0.7;
      ctx.moveTo(x - mw, my);
      ctx.lineTo(x - mw * 0.5, my - r * 0.18);
      ctx.lineTo(x, my);
      ctx.lineTo(x + mw * 0.5, my - r * 0.18);
      ctx.lineTo(x + mw, my);
      ctx.stroke();
      return;
    }

    // eyes (normal + eaten)
    var look = DIRS[g.dir] || DIRS.none;
    var ex = r * 0.34, ey = -r * 0.12, eR = r * 0.3, pR = r * 0.15;
    [-1, 1].forEach(function (side) {
      var cx = x + side * ex, cy = y + ey;
      ctx.fillStyle = '#fff';
      ctx.beginPath();
      ctx.ellipse(cx, cy, eR * 0.8, eR, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = '#1a2adb';
      ctx.beginPath();
      ctx.arc(cx + look.x * pR, cy + look.y * pR, pR, 0, Math.PI * 2);
      ctx.fill();
    });
  };

  PacGame.prototype.drawHUD = function () {
    var ctx = this.ctx;
    ctx.textBaseline = 'middle';

    ctx.fillStyle = '#ffd24a';
    ctx.font = '700 16px "Arial Black", Impact, sans-serif';
    ctx.textAlign = 'left';
    ctx.fillText('SCORE ' + this.score, 10, HUD_TOP / 2);

    ctx.textAlign = 'right';
    ctx.fillStyle = '#88ccff';
    ctx.fillText('HIGH ' + this.highScore, VW - 10, HUD_TOP / 2);

    // bottom: lives + level
    var by = HUD_TOP + ROWS * TILE + HUD_BOTTOM / 2;
    for (var i = 0; i < this.lives - 1; i++) {
      var lx = 18 + i * 26, ly = by;
      ctx.fillStyle = '#ffd24a';
      ctx.beginPath();
      ctx.moveTo(lx, ly);
      ctx.arc(lx, ly, 9, Math.PI * 0.78, Math.PI * 1.22, true);
      ctx.closePath();
      ctx.fill();
    }
    ctx.textAlign = 'right';
    ctx.fillStyle = '#c9a040';
    ctx.font = '700 14px "Arial Black", Impact, sans-serif';
    ctx.fillText('LEVEL ' + this.level, VW - 10, by);
  };

  PacGame.prototype.drawMessages = function (now) {
    var ctx = this.ctx;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    var cx = VW / 2;

    if (this.state === 'ready') {
      ctx.fillStyle = '#ffd24a';
      ctx.font = '700 22px "Arial Black", Impact, sans-serif';
      ctx.fillText(this.intro ? 'READY!' : 'READY!', cx, py(13));
    } else if (this.paused) {
      this.dim();
      ctx.fillStyle = '#fff';
      ctx.font = '700 26px "Arial Black", Impact, sans-serif';
      ctx.fillText('PAUSED', cx, VH / 2);
    } else if (this.state === 'gameover') {
      this.dim();
      ctx.fillStyle = '#ff4d4d';
      ctx.font = '700 30px "Arial Black", Impact, sans-serif';
      ctx.fillText('GAME OVER', cx, VH / 2 - 16);
      ctx.fillStyle = '#fff';
      ctx.font = '700 14px "Arial Black", Impact, sans-serif';
      ctx.fillText('SCORE ' + this.score, cx, VH / 2 + 14);
      ctx.fillStyle = '#88ccff';
      ctx.fillText('PRESS R / TAP TO PLAY AGAIN', cx, VH / 2 + 38);
    }
  };

  PacGame.prototype.dim = function () {
    var ctx = this.ctx;
    ctx.fillStyle = 'rgba(0,0,0,0.62)';
    ctx.fillRect(0, 0, VW, VH);
  };

  /* ─────────────────────────────────────────────────────────
     Audio (WebAudio, no assets) — mirrors the hadouken egg
     ───────────────────────────────────────────────────────── */
  PacGame.prototype.initAudio = function () {
    var AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) { this.audio = null; return; }
    try {
      this.audio = new AC();
      this.master = this.audio.createGain();
      this.master.gain.value = 0.5;
      this.master.connect(this.audio.destination);
    } catch (_) { this.audio = null; }
    this.wakaFlip = false;
  };
  PacGame.prototype.resumeAudio = function () {
    if (this.audio && this.audio.state === 'suspended') this.audio.resume();
  };
  PacGame.prototype.toggleMute = function () {
    this.muted = !this.muted;
    if (this.master) this.master.gain.value = this.muted ? 0 : 0.5;
    if (this.muteBtn) {
      this.muteBtn.innerHTML = this.muted ? '&#128263;' : '&#128266;';
      this.muteBtn.setAttribute('aria-pressed', this.muted ? 'true' : 'false');
    }
  };
  PacGame.prototype.beep = function (type, f0, f1, dur, peak) {
    if (!this.audio || this.muted) return;
    this.resumeAudio();
    var t = this.audio.currentTime;
    var o = this.audio.createOscillator(), g = this.audio.createGain();
    o.type = type;
    o.frequency.setValueAtTime(f0, t);
    if (f1 !== f0) o.frequency.exponentialRampToValueAtTime(Math.max(1, f1), t + dur);
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(peak, t + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g).connect(this.master);
    o.start(t); o.stop(t + dur + 0.02);
  };
  PacGame.prototype.waka = function () {
    this.wakaFlip = !this.wakaFlip;
    this.beep('square', this.wakaFlip ? 320 : 200, this.wakaFlip ? 200 : 320, 0.07, 0.14);
  };
  PacGame.prototype.bigEat = function () { this.beep('square', 180, 520, 0.22, 0.18); };
  PacGame.prototype.eatGhostSound = function () {
    this.beep('square', 400, 1000, 0.18, 0.2);
    var self = this;
    setTimeout(function () { self.beep('square', 700, 1400, 0.14, 0.16); }, 90);
  };
  PacGame.prototype.sirenOn = function () { this.beep('sawtooth', 300, 520, 0.35, 0.08); };
  PacGame.prototype.death = function () {
    if (!this.audio || this.muted) return;
    var self = this, steps = 8;
    for (var i = 0; i < steps; i++) {
      (function (i) {
        setTimeout(function () { self.beep('sawtooth', 700 - i * 70, 620 - i * 70, 0.13, 0.16); }, i * 110);
      })(i);
    }
  };
  PacGame.prototype.playReady = function () {
    if (!this.audio || this.muted) return;
    var self = this, notes = [392, 523, 659, 784];
    notes.forEach(function (n, i) {
      setTimeout(function () { self.beep('square', n, n, 0.14, 0.13); }, i * 130);
    });
  };

  /* ─────────────────────────────────────────────────────────
     Boot
     ───────────────────────────────────────────────────────── */
  // Nothing else to do — the delegated input listener and
  // scanExisting() above wire everything up.
})();
